import React from 'react';

const ItemContext = /*#__PURE__*/React.createContext({});

const ListContext = /*#__PURE__*/React.createContext({});

export { ItemContext, ListContext };
